module.exports = __webpack_public_path__ + "img/helix.7aa41fdc.png";